import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, Row, Spin } from 'antd';
import axios from 'axios';
import { axiosErrorHandler } from '../../../../../../swzutils';
import { isUserMultiTenant } from '../../../../../../swzutils/UserPermissionsUtil';
import TenantSelect from "../../../../components/TenantSelect";
import HelpLabel from "../../../../components/HelpLabel";
import { EditMode } from "../../../../enums/EditMode";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../../../store";
import { loggedInUserSelector } from "../../../../../../store/slice/auth";
const SpecialRequirementsEditForm = ({ specialRequirementId, mode }) => {
    const [form] = Form.useForm();
    const [showSpinner, setShowSpinner] = useState(false);
    const navigate = useNavigate();
    const loggedInUser = useAppSelector(loggedInUserSelector);
    useEffect(() => {
        loadSpecialRequirement();
    }, [specialRequirementId]);
    const backToList = () => {
        navigate('/app/consignments/special-requirements/list');
    };
    const save = (formValues) => {
        setShowSpinner(true);
        let saveUri = '/admin/v1/special-requirements/';
        let saveMethod = "post";
        if (specialRequirementId && mode == EditMode.EDIT) {
            saveUri += specialRequirementId;
            saveMethod = "put";
        }
        axios(saveUri, {
            method: saveMethod,
            data: {
                "tenantId": isUserMultiTenant(loggedInUser) ? formValues.tenantId : undefined,
                "title": formValues.title,
                "acceptDeclaration": formValues.acceptDeclaration,
                "completeDeclaration": formValues.completeDeclaration
            }
        })
            .then(( /*response*/) => backToList())
            .catch(axiosErrorHandler)
            .finally(() => setShowSpinner(false));
    };
    const loadSpecialRequirement = () => {
        if (specialRequirementId && mode == EditMode.EDIT) {
            setShowSpinner(true);
            axios.get(`/admin/v1/special-requirements/${specialRequirementId}`)
                .then(response => {
                const specialRequirement = response.data;
                form.setFieldsValue({
                    "tenantId": specialRequirement.tenant?.id,
                    "title": specialRequirement.title,
                    "acceptDeclaration": specialRequirement.acceptDeclaration,
                    "completeDeclaration": specialRequirement.completeDeclaration
                });
            })
                .catch(axiosErrorHandler)
                .finally(() => setShowSpinner(false));
        }
    };
    return (_jsx(Spin, { spinning: showSpinner, children: _jsxs(Form, { layout: "vertical", onFinish: save, form: form, children: [_jsxs(Card, { title: "Special Requirement Details", type: "inner", variant: 'borderless', children: [isUserMultiTenant(loggedInUser) &&
                            _jsx(Form.Item, { name: "tenantId", label: "Profile", children: _jsx(TenantSelect, { allowClear: true }) }), _jsx(Form.Item, { name: "title", label: "Title", rules: [
                                { required: true, message: 'Please input a mobile number for this rule.' },
                                { max: 250, message: 'Please limit the title to 250 characters.' }
                            ], children: _jsx(Input, {}) }), _jsxs(Row, { gutter: 10, children: [_jsx(Col, { md: 24, xl: 12, children: _jsx(Form.Item, { name: "acceptDeclaration", label: _jsx(HelpLabel, { title: "Accept Declaration", size: "large", helpText: _jsx("div", { children: _jsxs("p", { children: ["When a driver ", _jsx("strong", { children: "accepts" }), " a delivery with this special requirement they will be asked to accept this declaration"] }) }) }), children: _jsx(Input.TextArea, { autoSize: {
                                                minRows: 6
                                            } }) }) }), _jsx(Col, { md: 24, xl: 12, children: _jsx(Form.Item, { name: "completeDeclaration", label: _jsx(HelpLabel, { title: "Complete Declaration", size: "large", helpText: _jsx("div", { children: _jsxs("p", { children: ["When a driver ", _jsx("strong", { children: "completes" }), " a delivery with this special requirement they will be asked to accept this declaration"] }) }) }), children: _jsx(Input.TextArea, { autoSize: {
                                                minRows: 6
                                            } }) }) })] })] }), _jsxs(Row, { gutter: 10, className: "no-margin", children: [" ", _jsx(Col, { xs: 6, sm: 4, children: _jsx(Button, { block: true, type: "default", htmlType: "submit", size: "large", children: "Save" }) }), _jsx(Col, { xs: 1, children: "\u00A0" }), _jsx(Col, { xs: 6, sm: 4, children: _jsx(Button, { block: true, type: "default", onClick: backToList, size: "large", children: "Cancel" }) })] }), _jsx("p", { children: "\u00A0" })] }) }));
};
export default SpecialRequirementsEditForm;
